define('tracks/video-play',["require", "exports", "../tracks/track-state", "../tracks/track-store"], function (require, exports, trackState, trackStore) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    var track;
    var player = null;
    function init(trackId) {
        if (!document.getElementById("ytplayer"))
            return;
        // Inject YouTube API script
        var tag = document.createElement("script");
        tag.src = "//www.youtube.com/player_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        // Get track data
        var futureTrack = trackStore.getTrackData(trackId);
        // TODO: Subscribe to focus updates?
        window.onYouTubePlayerAPIReady = function () {
            futureTrack.then(function (result) {
                var videoId = getVideoId(result.videoUrl || "");
                if (videoId) {
                    track = result;
                    player = new YT.Player("ytplayer", {
                        videoId: videoId,
                        startSeconds: track.videoTime,
                        events: {
                            onReady: onPlayerReady,
                            onStateChange: onPlayerStateChange
                        }
                    });
                }
            });
        };
    }
    exports.init = init;
    var initVideoSeek = true;
    var initVideoMuted = false;
    function onPlayerReady() {
        initVideoMuted = player.isMuted();
        player.mute();
        player.seekTo(track.videoTime, true);
        // Start updating current time periodically
        setInterval(updateTime, 33);
    }
    function onPlayerStateChange(e) {
        if (e.data === YT.PlayerState.PLAYING && initVideoSeek) {
            initVideoSeek = false;
            player.pauseVideo();
            if (!initVideoMuted) {
                player.unMute();
            }
        }
        else if (e.data === YT.PlayerState.ENDED) {
            trackState.focusUpdates.post(undefined);
        }
    }
    var previousTime = -1;
    function updateTime() {
        var playerTime = player.getCurrentTime();
        if (track !== undefined && playerTime !== previousTime) {
            previousTime = playerTime;
            // Emit focus events
            var startTime = track.trim.min || track.data[0].millis;
            var playerStartTime = playerTime - track.videoTime;
            var trackTime_1 = startTime + playerStartTime * 1000;
            var index = track.data.findIndex(function (d) { return trackTime_1 < d.millis; });
            if (index > 0) {
                var point = track.data[index];
                trackState.focusUpdates.post(point, track);
            }
        }
    }
    /**
     * Parse youtube videoid from url
     */
    function getVideoId(videoUrl) {
        if (videoUrl.startsWith("https://www.youtube.com/watch?v=")) {
            videoUrl = videoUrl.replace("https://www.youtube.com/watch?", "");
            // Parse query string
            var kv = videoUrl.split("&")
                .find(function (param) { return param.startsWith("v="); });
            if (kv) {
                return kv.substring(2);
            }
        }
        else if (videoUrl.startsWith("https://youtu.be/")) {
            return videoUrl.replace("https://youtu.be/", "");
        }
        return undefined;
    }
});
//# sourceMappingURL=/assets/javascripts/tracks/video-play.js.map;
